export const getUserUrl = (baseUrl: string) => {
  const userUrl = `${baseUrl}/user`
  return {
    AGREEMENT: (user_id: number) => `${userUrl}/${user_id}/agreement`,
    CONSULT_STYLE: (user_id: number) => `${userUrl}/${user_id}/consult-style`, // get, update
    USER_INFO: (user_id: number) => `${userUrl}/${user_id}`, // get, update, delete
    VERIFY_PIN: `${userUrl}/pin/verify-pin`,
    PIN_EXISTS: `${userUrl}/pin/pin-exists`,
    SET_PIN: `${userUrl}/pin/set-pin`
  }
}
